// extracted by mini-css-extract-plugin
export var columnItem = "_dh-3";
export var columnItemDraggable = "_dh-4";
export var dragHandle = "_dh-0";
export var dragHandleHovered = "_dh-1";
export var dropdown = "_dh-5";
export var dropdownContent = "_dh-7";
export var dropdownInner = "_dh-6";
export var filterDropdownHeader = "_dh-8";
export var icon = "_dh-2";
export var sectionDivider = "_dh-9";